import { MutationTree } from 'vuex'
import { PointsOfInterest } from './types'

export const mutations: MutationTree<PointsOfInterest> = {
  setPointsOfInterest(state, points) {
    state.pointsOfInterest = points
  },
  setFilterPointsOfInterestByString(state, { filterPointsOfInterest }) {
    state.filteredPointsOfInterest = filterPointsOfInterest
  },
  addPointToMap(state, { pointOnMap }) {
    state.pointsOfInterestOnMap.push(pointOnMap)
  },
  resetFilterPointsOfInterestState(state) {
    state.filteredPointsOfInterest = state.pointsOfInterest
  },
  setShowPointsOfInterestLoadingButton(state) {
    state.showPointsOfInterestLoadingButton = !state.showPointsOfInterestLoadingButton
  },
  setPointsOfInterestOnMap(state, pointsOfInterest) {
    state.pointsOfInterestOnMap = pointsOfInterest
  },
  destroyPointsOfInterestOnMap(state) {
    state.pointsOfInterestOnMap = []
  }
}
